module.exports = __webpack_public_path__ + "img/Dentist.93177a09.png";